export function syncMessage(code: string) {
  if (["sync-control-race", "sync-checkpoint-stale", "sync-cannot-revoke-current"].includes(code))
    return "devicesChanged";
  if (code === "sync-setup-in-progress") return "setupInProgress";
  if (code === "sync-setup-denied") return "setupReauthentication";
  if (code === "sync-root-exists") return "existingPairedRoot";
  if (code === "sync-initial-upload-pending") return "initialUploadPending";
  if (code === "sync-draft-save-required") return "draftSaveRequired";
  if (code === "sync-backup-current-required") return "backupCurrentRequired";
  if (code === "sync-maintenance") return "maintenance";
  if (code === "sync-rate-limit") return "errorRate";
  if (["sync-google-reconnect", "sync-drive-denied"].includes(code)) return "errorGoogleAuth";
  if (
    [
      "sync-cipher-invalid",
      "sync-format",
      "sync-scope-mismatch",
      "sync-operation-signature",
      "sync-upload-mismatch",
      "sync-checkpoint-integrity",
      "sync-checkpoint-format",
      "sync-decompression-limit",
      "sync-remote-file-removed",
      "sync-drive-response-format",
    ].includes(code)
  )
    return "errorCorrupt";
  if (
    [
      "sync-password-short",
      "sync-recovery-format",
      "sync-recovery-file-mismatch",
      "sync-dataset-mismatch",
      "sync-recovery-open-failed",
      "sync-recovery-file-verify-required",
    ].includes(code)
  )
    return "errorRecovery";
  if (code === "sync-clock-rollback") return "errorClock";
  if (code === "sync-update-required") return "errorUpdate";
  if (["sync-account-denied", "sync-sign-in-required", "sync-session-refresh-required"].includes(code))
    return "errorAccount";
  if (code === "sync-device-revoked" || code === "sync-device-signature") return "errorDevice";
  if (["sync-capacity-limit", "sync-drive-quota"].includes(code)) return "errorCapacity";
  if (
    ["sync-conflict-needs-choice", "sync-resolution-stale", "sync-view-stale", "sync-relation-conflict"].includes(code)
  )
    return "errorConflict";
  if (code === "sync-generation-mismatch" || code === "sync-new-generation-required" || code === "sync-data-restored")
    return "errorGeneration";
  if (code === "sync-key-version-required") return "errorKey";
  if (code === "sync-v1-migration-required" || code === "sync-migration-source-unknown") return "errorLegacy";
  if (code === "sync-paused") return "errorPaused";
  if (code === "sync-locked") return "errorReadOnly";
  if (
    ["sync-not-released", "sync-provider-unconfigured", "sync-grant-unconfigured", "sync-setup-unavailable"].includes(
      code,
    )
  )
    return "notConfigured";
  if (
    [
      "sync-drive-request-failed",
      "sync-google-reconnect",
      "sync-connection-required",
      "sync-control-unavailable",
      "sync-rate-limit",
    ].includes(code)
  )
    return "errorConnection";
  return "errorGeneric";
}
